import { fromEvent } from "rxjs";
import { debounceTime, shareReplay } from "rxjs/operators";
export var resize$ = fromEvent(window, "resize").pipe(shareReplay(), debounceTime(50));
export var focus$ = fromEvent(window, "focus").pipe(shareReplay());
export var blur$ = fromEvent(window, "blur").pipe(shareReplay(), debounceTime(5000));
export var click$ = fromEvent(window, "click");
export var fullScreen$ = fromEvent(window, "fullscreenchange").pipe(shareReplay());



//////////////////
// WEBPACK FOOTER
// ./src/events/eventsBrowser.ts
// module id = 204
// module chunks = 3